module.exports = __webpack_public_path__ + "static/media/alcTransparent.e1d5f3c6.png";